import React from 'react'
import {  Outlet } from 'react-router-dom'
import LeadCoordinatorSettingMenu from './leadCoordinatorSettingMenu'


const LeadCoordinatorSettings = () => {

  return (
    <>
    <section className='dash-main' style={{marginTop: '-65px'}}>
    <LeadCoordinatorSettingMenu/>
    
    <div className="dash-main-R" style={{minHeight:'75vh'}}>
        <div className="dash-side-R-body">
            <Outlet/>
        </div>
    </div>
    </section>
    </>
  )
}

export default LeadCoordinatorSettings